import React, { Component } from 'react';
import './App.css';
import Navi from './Navi';
import Intro from './Intro';
import ScaleNational from './ScaleNational';
import ScaleMetropolitan from './ScaleMetropolitan';
import ScaleNeighborhood from './ScaleNeighborhood';
import ScaleIndividual from './ScaleIndividual';
import ScaleBubble from './ScaleBubble';
import 'nodelist-foreach-polyfill';
import Outro from './Outro';

class App extends Component {

  constructor(props) {
    let cities = ["vancouver", "sydney", "auckland"];
    let scales = ["intro", "national", "metropolitan", "neighborhood", "individual"];
    super(props);

    let pathSplit = window.location.pathname.slice(1).split('-');
    let urlVals = this.decodeParams(window.location);

    this.state = {
      cities: cities,
      city: urlVals.city ? urlVals.city : cities[0],
      scales: scales,
      scale: urlVals.scale ? urlVals.scale : scales[0],
      foundComponent: urlVals.scale ? false : true,
      componentInView: "intro",
      width: 0,
      componentStates: urlVals.componentStates ? urlVals.componentStates : {
        bubble: {
          filter: "Total population"
        },
        map: {
          variables: [0, 0],
          mode: 'traditional'
        },
        tree: {
          year: 2012,
          category: 'Skilled'
        },
        sankey: {
          year: "1991"
        },
        dashboard: {
          filters: ["99", "99", "99", "99", "99"]
        }
      }
    }

    this.handleNaviCityButtonClick = this.handleNaviCityButtonClick.bind(this);
    this.handleNaviScaleButtonClick = this.handleNaviScaleButtonClick.bind(this);
    this.updateUrl = this.updateUrl.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  decodeParams(path) {
    let state = path.href.split('#')[1];
    if (state) {
      let parts = state.split('?');

      let city = parts[0].split('-')[0];
      let scale = parts[0].split('-')[1];

      let componentStates = {};

      for (var i = 1; i < parts.length; i++) {
        let subparts = parts[i].split(';');
        componentStates[subparts[0]] = {};
        for (var j = 1; j < subparts.length; j++) {
          let attr = subparts[j].split(':');
          let val = attr[1];
          if (attr[1].split(',').length > 1) {
            val = attr[1].split(',');
            val = val.map(v => { return v.replace(/%20/g, ' ') } );
          } else {
            val = val.replace('%20', ' ')
          }
          componentStates[subparts[0]][attr[0]] = val;
        }
      }

      return {city, scale, componentStates};
    }

    return {}
  }

  shouldComponentUpdate(newProps, newState) {
    if (newState.city === this.state.city && newState.componentStates === this.state.componentStates && newState.width === this.state.width) {
      return false;
    }

    return true;
  }

  handleNaviCityButtonClick(userClickedCity) {
    this.setState({
      city: userClickedCity
    }, this.updateUrl);
  }

  handleNaviScaleButtonClick(userClickedScale) {
    this.setState({
      scale: userClickedScale
    }, this.jumpIntoView(userClickedScale));
  }

  jumpIntoView(elem) {
    if (document.getElementById(elem) && window.location.hash) {
      window.scrollTo(0, document.getElementById(elem).offsetTop - 200);
    }
    else if (document.getElementById(elem) && !window.location.hash) {
      window.scrollTo({
        top: document.getElementById(elem).offsetTop - 200,
        behavior: 'smooth'
      });
    }
  }



  // Tracks as user scrolls down a page and changes
  // state.scale, state.componentInView, and URL params

  initObservers() {
    let observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: []
    };

    // let thresholdSet = [];
    // for (let i = 0.1; i <= 1.00; i += 0.03) thresholdSet.push(i);

    let components = document.querySelectorAll('.Component');
    components.forEach((elem) => {
      observerOptions.threshold = 0.5;
      observerOptions.rootMargin = "100px 0px 100px 0px";
      let observer = new IntersectionObserver(this.intersectionCallback.bind(this), observerOptions);
      observer.observe(elem);
    })
  }

  intersectionCallback(components) {
    components.forEach((component) => {
      if (this.state.componentInView !== component.target.id && (component.intersectionRect.top + component.intersectionRect.height) > 500)
        this.setState({
          componentInView: component.target.id
        }, this.updateScaleOnScroll
        );
    });
  }

  updateScaleOnScroll() {
    if (this.state.scales.includes(this.state.componentInView))
      this.setState({
        scale: this.state.componentInView
      });

    this.updateUrl();
  }

  // NOTE: To use this function for children components to update the URL,
  // pass as props to the child component, pass it an array of strings of
  // the params to be put into the URL

  updateUrl(params, sectionId) {
    let a = "#" + this.state.city + "-" + this.state.componentInView;

    for (let comp in this.state.componentStates) {
      a += "?" + comp;
      for (let key in this.state.componentStates[comp]) {
        a += ";" + key + ":" + this.state.componentStates[comp][key];
      }
    }

    // if (window.history.pushState) {
    //   window.history.pushState(null, null, encodeURI(a));
    //   if (sectionId) {
    //     this.jumpIntoView(sectionId);
    //     this.setState({
    //       componentInView: sectionId
    //     })
    //   }
    // }
    // else {
      window.location.hash = encodeURI(a);
    // }
  }

  updateWindowDimensions() {
    let width = window.innerWidth;
    if (width < 768) {
      width -= 40;
    } else {
      width -= 200;
    }

    width = Math.min(1400, width);

    this.setState({ width });
  }


  componentDidMount() {
    this.initObservers();
    let scale = this.state.scale;
    window.addEventListener('load', () => {
      if (scale !== "intro") this.jumpIntoView(scale);

    });

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  update(componentName, newState) {
    let updatedState = {...this.state.componentStates[componentName], ...newState};
    let finalStateUpdate = {...this.state.componentStates};
    finalStateUpdate[componentName] = updatedState;
    this.setState({componentStates: finalStateUpdate}, this.updateUrl);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  render() {
    return (
      <div className="App">
        <div className="Header">
          <div className="title">
            Superdiversity
          </div>
          <div className="subtitle">
            Today's migration has made cities more diverse than ever—in multiple ways
          </div>
          <div className="byline">
            By <a href="https://www.mmg.mpg.de/steven-vertovec">Steven Vertovec</a>, <a href="http://blogs.ubc.ca/dhiebert/">Daniel Hiebert</a>, <a href="https://research.monash.edu/en/persons/alan-gamlen">Alan Gamlen</a> and <a href="http://www.massey.ac.nz/massey/expertise/profile.cfm?stref=710200">Paul Spoonley</a>
          </div>
        </div>

        <div className="content">
          <Intro
            width={this.state.width}
          />
        </div>

        <Navi
          cities={this.state.cities}
          city={this.state.city}
          handleNaviCityButtonClick={this.handleNaviCityButtonClick}
        />

        <div className="content" id="scales">
          <ScaleNational
            width={this.state.width}
            height={300}
            city={this.state.city}
            params={this.state.componentStates.tree}
            update={(x) => this.update("tree", x)}
          />
          <ScaleMetropolitan
            update={(x) => this.update("sankey", x)}
            params={this.state.componentStates.sankey}
            city={this.state.city}
            width={this.state.width}
          />
          <ScaleBubble
            update={(x) => this.update("bubble", x)}
            params={this.state.componentStates.bubble}
            city={this.state.city}
            width={this.state.width}
          />
          <ScaleNeighborhood
            update={(x) => this.update("map", x)}
            city={this.state.city}
            params={this.state.componentStates.map}
          />
          <ScaleIndividual
            city={this.state.city}
            params={this.state.componentStates.dashboard}
            update={(x) => this.update("dashboard", x)}
          />
          <Outro />
        </div>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js